import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import "./index.css";

import {
  resetGetCinData,
  resetGetDinData,
  resetGetPanData,
} from "../../../redux/features/verifyPAN/verifyPAN";

import ICONS from "../../../assets/Icons";
import NavbarBoxComponent from "../../../components/_utils/NavbarBoxComponent";

const SettingsDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const services = useSelector((state) => state.refreshToken.services);

  // Pls Don't remove this part of code
  // const activeState = useSelector((state) => state.multientity.activeModules);

  // useEffect(() => {
  //   dispatch(activeModulesData([0, 8, 9, 5]));
  // }, []);

  // const filteredModules = modulesData.modules.filter((module) =>
  //   activeState.includes(module.id),
  // );

  useEffect(() => {
    dispatch(resetGetCinData());
    dispatch(resetGetDinData());
    dispatch(resetGetPanData());
  }, [dispatch]);

  const handleNavigate = async (type, requiredService, route) => {
    if (
      !services?.some((ser) => {
        return requiredService?.split(",")?.includes(ser);
      })
    ) {
      await navigate("/feature_not_assigned", {
        state: { unavailableService: requiredService },
      });
    } else {
      await navigate(route);
    }
  };

  const buttonConfig = [
    {
      title: "ENTERPRISE DATA",
      items: [
        {
          label: "Statistics",
          icon: ICONS.STATISTICS,
          route: "/settings/statistics",
          requiredService: "VStatistics",
        },
        {
          label: "Users",
          icon: ICONS.USERS,
          route: "/settings/user_view_all",
          requiredService: "MimicEntity,VEmp",
        },
        {
          label: "Roles",
          icon: ICONS?.ROLES_WITHOUT_CIRCLE,
          route: "/settings/role_view_all",
          requiredService: "Sup_VRole, MimicEntity",
          makeWhite: true,
        },
        {
          label: "Services",
          icon: ICONS?.SERVICES,
          route: "/settings/service_view_all",
          requiredService: "Sup_VService",
          makeWhite: true,
        },
        {
          label: "Features",
          icon: ICONS?.FEATURES,
          route: "/settings/feature_view_all",
          requiredService: "SERVICE_VIEW_FEATURE",
          makeWhite: true,
        },
        {
          label: "Devices",
          icon: ICONS.DEVICES,
          route: "/settings/devices_view_all",
          requiredService: "Sup_VDevice",
        },
        {
          label: "Entities",
          icon: ICONS.ENTITIES_WHITE,
          route: "/settings/entities_view_all",
          requiredService: "VEntity,MimicEntity",
        },
      ],
    },
    {
      title: "SET UP",
      items: [
        {
          label: "Security Center",
          icon: ICONS.SECURITY_CENTER,
          route: "/settings/security_center",
          requiredService: "PLogin",
        },
        {
          label: "Invoices",
          icon: ICONS.INVOICES,
          route: "/settings/invoices",
          requiredService: "VInvoice",
        },
        {
          label: "Test Matrix",
          icon: ICONS.TEST_MATRIX,
          route: "/settings/test_authorization_matrix",
          requiredService: "CAuth_matrix",
        },
        {
          label: "Categories",
          icon: ICONS.CATEGORY_SETUP,
          route: "/settings/category_dashboard",
          requiredService: "PLogin",
          makeWhite: true,
        },
        {
          label: "Notification Center",
          icon: ICONS.NOTIFICATION_SETUP,
          route: "/settings/notification_center",
          requiredService: "Admin,Notify",
        },
      ],
    },

    {
      title: "VERIFICATION",
      items: [
        {
          label: "CIN Verification",
          icon: ICONS.CIN_VERIFICATION,
          route: "/settings/CIN_verification",
          requiredService: "VCIN",
        },
        {
          label: "DIN Verification",
          icon: ICONS.DIN_VERIFICATION,
          route: "/settings/DIN_verification",
          requiredService: "VDIN",
        },
        {
          label: "PAN Verification",
          icon: ICONS.PAN_VERIFICATION,
          route: "/settings/PAN_verification",
          requiredService: "VPAN",
        },
        {
          label: "GST Verification",
          icon: ICONS.GST_VERIFICATION,
          route: "/settings/GST_verification",
          requiredService: "VGSTIN",
        },
        {
          label: "IFSC Verification",
          icon: ICONS.IFSC,
          route: "/settings/IFSC_verification",
          requiredService: "VIFSC",
        },
      ],
    },
  ];

  const renderButtons = (buttons) =>
    buttons.map((button, buttonIndex) => {
      const { label, icon, route, requiredService, comingSoon } = button;
      const isLastButton = buttonIndex === buttons.length - 1;

      return (
        <>
          <NavbarBoxComponent
            makeWhite={button?.makeWhite ?? false}
            iconRight={ICONS.ARROW_RIGHT_WHITE}
            iconLeft={icon}
            title={label}
            handleFunction={() => {
              if (comingSoon) {
                toast.info("Coming Soon", toast_position);
              } else {
                handleNavigate(label, requiredService, route);
              }
            }}
            isDisabled={
              !(
                requiredService &&
                (services?.some((ser) =>
                  requiredService?.split(",")?.includes(ser),
                ) ||
                  services?.includes("Admin"))
              )
            }
          />
          {/* <div
            className={`settings-divider Qsmd:w-navbar-box-component w-[95%] ${isLastButton ? "hidden" : "block"}`}
          /> */}
          <div
            className={`w-full ${isLastButton ? "hidden" : "block"} border border-primary-act `}
          />
        </>
      );
    });

  return (
    <div className="flex flex-col h-screen">
      {/* <div className="hidden Qmd:block h-navbar-height"></div> */}
      <div className="hidden Qsmd:block h-navbar-breadcrumb-height min-h-navbar-breadcrumb-height"></div>

      <div className="w-full max-w-tab-width-normal text-text-primary flex lg:gap-x-gap-md gap-x-gap-xl lg:mx-auto pb-padding-md  mt-margin-xl Qsmd:mt-margin-md">
        <div className="lg:hidden fixed w-full top-top-base bg-custom-card z-z-index-content flex items-center cursor-pointer">
          <div onClick={() => navigate("/home/profile_quick_menu")}>
            <img
              src={ICONS.CLOSE}
              alt="Close"
              className="w-icon-md h-icon-md m-margin-md"
            />
          </div>
          <h1 className="text-base flex-1 text-text-primary">Settings</h1>
        </div>
        <div
          // className="flex-1 grid grid-cols-1 lg:grid-cols-2 sm:grid-cols-1 max-w-screen-lg mx-auto mt-margin-xl"
          className="grid lg:grid-cols-2 grid-cols-1 lg:w-[496px] w-full lg:px-padding-base px-padding-sm gap-x-gap-xl gap-y-gap-lg mt-margin-md Qsmd:pt-padding-base pt-padding-md"
        >
          {buttonConfig.map((data, index) => (
            <div
              key={index}
              // className="pb-padding-md"
              className="flex flex-col gap-gap-md"
              style={{ height: "fit-content" }}
            >
              <h2 className="text-text-primary text-font-md font-semibold uppercase">
                {data.title}
              </h2>
              <div className="flex flex-col gap-gap-xs w-full">
                {renderButtons(data.items)}
              </div>
            </div>
          ))}
        </div>

        <div className="hidden sm:flex mx-auto my-auto">
          <img
            src={ICONS?.SETTINGS_GRAPHICS}
            alt="Settings"
            className=" h-graphic-rectangle-height-lg w-graphic-width-lg flex-shrink-0"
          />
        </div>
      </div>

      {/* Pls Don't remove this component */}
      {/* <CommonPoweredBy
        modulesList={filteredModules}
        descriptions={modulesData?.descriptions[0].text}
      /> */}
    </div>
  );
};

export default SettingsDashboard;
